import React, { useEffect, useState } from 'react';

interface Props {
  clientName: string;
  businessName: string;
}

const SuccessScreen: React.FC<Props> = ({ businessName }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center p-6">
      <div
        className={`text-center max-w-md transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        {/* Animated checkmark */}
        <div className="relative w-20 h-20 mx-auto mb-8">
          <div className="w-20 h-20 rounded-full border-2 border-lime-400/30 animate-pulse-slow absolute inset-0" />
          <div className="w-20 h-20 rounded-full border border-lime-400 flex items-center justify-center">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M6 14l6 6 10-10"
                stroke="#C8F135"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        <h1 className="font-display text-3xl font-semibold text-white mb-3">
          You're all set.
        </h1>
        <p className="text-gray-400 text-sm leading-relaxed mb-2">
          We've received everything for <span className="text-white font-medium">{businessName || 'your project'}</span>.
        </p>
        <p className="text-gray-500 text-sm leading-relaxed mb-10">
          Edwin and Derek will review your intake and reach out within 24 hours to schedule your kickoff call. Check your email for a confirmation.
        </p>

        <div className="border border-dark-600 rounded-xl p-5 text-left space-y-3">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">What to expect next</p>
          {[
            { label: 'Within 24 hrs', desc: 'We review your intake & prep' },
            { label: 'Kickoff call', desc: 'Deep dive into your vision' },
            { label: 'Proposal', desc: 'Custom scope, timeline & pricing' },
            { label: "Let's build", desc: 'We get to work' },
          ].map((item, i) => (
            <div key={i} className="flex items-start gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-lime-400 mt-1.5 flex-shrink-0" />
              <div>
                <span className="text-sm font-medium text-white">{item.label}</span>
                <span className="text-sm text-gray-500 ml-2">{item.desc}</span>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-gray-600">
          Questions? Email us at{' '}
          <a href="mailto:Create@SiteStackCo.com" className="text-lime-400 hover:underline">
            Create@SiteStackCo.com
          </a>
        </p>

        <p className="mt-6 font-display text-sm italic text-dark-500">SiteStackCo</p>
      </div>
    </div>
  );
};

export default SuccessScreen;
